module.exports = __webpack_public_path__ + "img/pratique.e93bc38d.jpg";